
import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fake',
  templateUrl: './fake.component.html',
  styleUrls: ['./fake.component.css']
})
export class FakeComponent implements OnInit {

    constructor(public httpClient: HttpClient){}

    ngOnInit(): void {
        this.init_list();
    }

    data:any=[];
    edit_data:any={type:'-2',country_code:'',phone_num:'',password:'',is_enable:'0'};
    loading:boolean=true;
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    menu_now:string = '1';
    now:string = '1';
    act = '0';
    edit_id:any = 0;
    search_type = '-2';
    search_enable_type = '-2';
    search_phone = '';
    
    menu_list:menulist = [
        {id:'1',name:'假電話列表'},
    ]

    tcontent = [
        {title:'帳號類型',content:'type',type:3},
        {title:'國碼',content:'country_code'},
        {title:'電話號碼',content:'phone_num'},
        {title:'六位數字驗證碼',content:'password'},
        {title:'狀態',content:'is_enable',type:3},
        {title:'操作',content:'gg',type:3},
    ];

    account_type_list:menulist = [
        {id:'1',name:'工程師用'},
        {id:'2',name:'陪聊'},
        {id:'3',name:'外部免驗證碼使用'},
    ]

    enable_list:menulist = [
        {id:'0',name:'停用'},
        {id:'1',name:'啟用'},
    ]
    

    default(){
        this.edit_data = {type:'-2',country_code:'',phone_num:'',password:'',is_enable:'0'};
    }

    default_page(){
        this.pageobj = {page:0,count:10,total_count:0};
        this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
    }

    save(act){
        this.act = act;
        if(this.edit_data.type == '-2'){

            Swal.fire({
                title: "請選擇帳號類型!",
                icon: "error"
            });

            return;
        }

        if(this.edit_data.country_code  == ''){

            Swal.fire({
                title: "國碼不為空!",
                icon: "error"
            });

            return;
        }

        if(this.edit_data.phone_num  == ''){

            Swal.fire({
                title: "電話號碼不為空!",
                icon: "error"
            });

            return;
        }

        if(this.edit_data.password  == ''){

            Swal.fire({
                title: "驗證碼不為空!",
                icon: "error"
            });

            return;
        }

        const numStr = this.edit_data.phone_num.toString();
    
        if(numStr.charAt(0) != '8'){
            Swal.fire({
                text: "確認電話不能重複",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "確定",
                cancelButtonText: "取消",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    const body = {
                        page: this.pageobj.page,
                        count:this.pageobj.count,
                        menu_now:this.menu_now,
                        act:act,
                        edit_data:this.edit_data,
                        id:this.edit_id
                    };
                    this.httpClient.post<any>("/get_fake_account_list.php",body).subscribe(res => {
                        this.loading = false;
                        if(res.status){
                            if(act == '1'){
                                Swal.fire({
                                    title: "新增成功!",
                                    icon: "success"
                                });
                            }else{
                                Swal.fire({
                                    title: "修改成功!",
                                    icon: "success"
                                });
                            }
                         
                            this.act = '0';
                            this.init_list();
                        }else{
                            Swal.fire({
                                title: "電話號碼已重複!",
                                icon: "error"
                            });
                        }
                    });               
                }
            });  

        }else{
            this.loading = true;
            const body = {
                page: this.pageobj.page,
                count:this.pageobj.count,
                menu_now:this.menu_now,
                act:this.act,
                edit_data:this.edit_data,
                id:this.edit_id
            };
            console.log('body',body);
            this.httpClient.post<any>("/get_fake_account_list.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    if(act == '1'){
                        Swal.fire({
                            title: "新增成功!",
                            icon: "success"
                        });
                    }else{
                        Swal.fire({
                            title: "修改成功!",
                            icon: "success"
                        });
                    }
                    this.act = '0';
                    this.init_list();
                }else{
                    Swal.fire({
                        title: "電話號碼已重複!",
                        icon: "error"
                    });
                }
            });
        }        
    }

    choose_list(id){
        this.act = '3';
        this.edit_id = id;
        this.loading = true;
        const body = {
            page: this.pageobj.page,
            count:this.pageobj.count,
            menu_now:this.menu_now,
            act:this.act,
            id:id,
        };
        this.httpClient.post<any>("/get_fake_account_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.edit_data = res.data[0];
                this.act = '0';
            }
        });

    }

 
    choose(value:string){
        this.menu_now = value;
        this.pageobj.total_count = 0;
        this.pageobj = {page:0,count:10,total_count:0};
        this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));  
        this.init_list();  
    }

  
   
    init_list(){
        this.loading = true;
        const body = {
            page: this.pageobj.page,
            count:this.pageobj.count,
            menu_now:this.menu_now,
            act:this.act,
            search_type:this.search_type,
            search_enable_type:this.search_enable_type,
            search_phone:this.search_phone
        };
        this.httpClient.post<any>("/get_fake_account_list.php",body).subscribe(res => {
            this.loading = false;
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
            if(res.status){
                this.data = res.data
                this.pageobj.total_count = res.total_count
            }else{
                this.pageobj.total_count = 0
                this.data = [];
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        });
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    makecode(){
        this.edit_data.password =  Math.random().toString().slice(-6);
    }

}


